import React from 'react'
import { Button, Stack, Grid, IconButton, Avatar } from '@mui/material'
import logomeka from '../../assets/logo.png'
import iconeevent from '../../assets/event.png'
import iconediscover from '../../assets/discover.png'
import iconemusic from '../../assets/music.png'
import iconestats from '../../assets/stats.png'
import { useNavigate } from 'react-router-dom'
import Player from '../player/Player'
import withMK from '../../hoc/withMK'
import { QueueModalProps, withQueueModal } from '../../core/providers/QueueProvider'
import { ModalProviderValue, withModal } from '../../core/providers/ModalProvider'


interface SideMenuProps extends MKProps, QueueModalProps {
    modal: ModalProviderValue,
    user: any
}

const SideMenu = ({user, mk}: SideMenuProps) => {

    const navigate = useNavigate()
    
    const goToHome = async () => {
        navigate(`/`)
    }
    
    const goToUser = async () => {
        navigate(user ? `/profile` : `/login`)
    }

    return <Grid size={2} sx={{ height: { xs: '10%', md: '10', lg: '100%'}, display: { xs: 'none', md: 'none', lg: 'flex'}}} justifyContent={'center'}>
        <Grid container sx={{ height: '100%'}}>
            <Grid size={12} sx={{ height: '83%'}}  >
                <Stack spacing={0} direction={'column'} sx={{ height: '100%'}}>
                    <Button sx={{ height: '20%'}} ><img alt="logo meka" height={'80%'} src={logomeka} onClick={goToHome} /></Button>
                    <Button sx={{marginTop: '4vh', height: '14%', padding: '8px'}}><img alt="logo event" height={'100%'} src={iconeevent} /></Button>
                    <Button sx={{marginTop: '4vh', height: '14%', padding: '8px'}}><img alt="logo music" height={'100%'} src={iconemusic} /></Button>
                    <Button sx={{marginTop: '4vh', height: '14%', padding: '8px'}}><img alt="logo discover" height={'100%'} src={iconediscover} onClick={goToHome} /></Button>
                    <Button sx={{marginTop: '4vh', height: '14%', padding: '8px'}}><img alt="logo stats" height={'100%'} src={iconestats} /></Button>
                </Stack>
            </Grid>
            <Grid size={12} alignContent={'center'} alignItems={'center'} alignSelf={'center'} sx={{ textAlign: 'center'}}>
                <IconButton sx={{padding: '4px'}} onClick={() => goToUser()}>
					<Avatar alt="User avatar" sx={{width: { xs: '35px', md: '40px', lg: '8vh' }, height: { xs: '35px', md: '40px', lg: '8vh' }}} src={user ? user.avatar_url : ''}  /> 
				</IconButton>
                { mk && mk.instance && mk.instance.queue.currentItem ? <Player /> : ''}

            </Grid>
        </Grid> 
    </Grid>
}

const bindings = {
    [MusicKit.Events.mediaItemDidChange]: 'mediaItem',
    [MusicKit.Events.queueItemsDidChange]: 'queueItems',
    [MusicKit.Events.queuePositionDidChange]: 'queuePosition',
    [MusicKit.Events.playbackStateDidChange]: 'playbackState',
}

export default withMK(
    withQueueModal(withModal( SideMenu )), 
    bindings
)